import { cn } from '@listening/utils/react-helpers';
import { RefreshDouble } from 'iconoir-react';

export function Spinner({ className }: { className?: string }) {
  return <RefreshDouble className={cn('h-4 w-4 animate-spin', className)} />;
}
